import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuration-examples-landing-page',
  templateUrl: './configuration-examples-landing-page.component.html',
  styleUrls: ['./configuration-examples-landing-page.component.css']
})
export class ConfigurationExamplesLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
